import { render, staticRenderFns } from "./LookCompany.vue?vue&type=template&id=c6100f56&"
import script from "./LookCompany.vue?vue&type=script&lang=js&"
export * from "./LookCompany.vue?vue&type=script&lang=js&"
import style0 from "./LookCompany.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports